import {get} from 'lodash';
import * as STEP_NAMES from '../../../../../constants/activation-brief-steps';
import {getStepTitle} from '../../../../../helpers/activations/default-texts';
import * as STEP_STATES from '../../../../../constants/activation-brief-step-states';

export default {
    props: {
        brief: {
            type:     Object,
            required: true,
        },
        steps: {
            type:     Object,
            required: true,
        },
        currentStep: {
            type: Object,
        },
        isPreview: {
            type:     Boolean,
            required: true,
        },
        isBriefAccepted: {
            type:     Boolean,
            required: true,
        },
        isBriefEditable: {
            type:     Boolean,
            required: true,
        },
        briefStatus: {
            type: String,
        },
    },
    data() {
        return {
            STEP_NAMES,
        };
    },
    computed: {
        step() {
            return this.steps[this.stepName];
        },
        stepTitle() {
            return getStepTitle(this.brief, this.stepName);
        },
        currentStepName() {
            return get(this, 'currentStep.name', null);
        },
        showStep() {
            return !!this.steps[this.stepName];
        },
        state() {
            if (!this.step) {
                return STEP_STATES.PENDING;
            }

            if (this.step.is_started && (!this.step.is_complete || !this.step.is_valid)) {
                return STEP_STATES.ERROR;
            }

            if (this.stepName === this.currentStepName) {
                return STEP_STATES.CURRENT;
            }

            if (this.step.is_complete) {
                return STEP_STATES.COMPLETED;
            }

            return STEP_STATES.PENDING;
        },
        isComplete() {
            return this.state === STEP_STATES.COMPLETED;
        },
    },
};
